export class PacketFileTypes{
    static get PROOF_SHEET(){return 'proof-sheet'}
    static get META(){return 'meta'}
    static get PACKET(){return 'packet'}
    static get DESCRIPTION(){return 'description'}
}
